window.addEventListener('load', async () => {

  /*------
  メインビジュアル
  ------*/
  const switchMvImg = () => {
    const mvSliderElement = document.querySelector('.js-mv_slider')
    if(!mvSliderElement)
      return

    const mvSliderItemElements = mvSliderElement.children
    if (mvSliderItemElements.length === 0)
      return

    // 1枚目フェードイン
    mvSliderItemElements[0].classList.add('is-active')

    // 画像が1枚ならフェードインして終了
    if(mvSliderItemElements.length === 1)
      return

    // 画像が2枚以上の場合は一定時間でフェード切り替え
    let currentIndex = 0
    window.setInterval(() => {
      mvSliderItemElements[currentIndex].classList.remove('is-active')

      currentIndex = (currentIndex + 1) % mvSliderItemElements.length;

      mvSliderItemElements[currentIndex].classList.add('is-active')
    }, 5000)
  }

  switchMvImg()

  /*------
  instagram スライダー
  ------*/
  // dev/common/js/insta.es6を流用
  const instaEls = document.querySelectorAll('.js-insta')

  const getInstaInfo = (cb) => {
    const xhr = new XMLHttpRequest()
    return new Promise((resolve, reject) => {
      xhr.open('GET', 'https://towers-sub.jp/list.json', true)
      xhr.send()
      xhr.onreadystatechange = function () {
        if (xhr.readyState !== 4) return
        if (xhr.status === 200 || xhr.status === 304) {
          try {
            const instaImages = JSON.parse(xhr.responseText)
            const listItems = []
            for (let i = 0; i < 15; i++) {
              const instaImage = instaImages[i]
              if (!instaImage) continue
              listItems.push(`<li class="top-insta_list--item"><a href="${instaImage.permalink}" target="_blank"><img src="${instaImage.media_url}" alt="" class="top-insta_list--img" width="216"></a></li>`)
            }
            const html = listItems.join('')
            instaEls.forEach((insta) => {
              insta.innerHTML += html
            })
            if (cb) cb()
            resolve()
          } catch (e) {
            reject(e)
          }
        } else {
          reject(new Error('request failed: ' + xhr.status))
        }
      }
      xhr.onerror = () => reject(new Error('network error'))
    })
  }

  if (instaEls.length > 0) {
    getInstaInfo()
  }

  // 簡体字の時はinsta自体を非表示
  const isZhcnUrl = window.location.href.includes('zhcn')
  if (isZhcnUrl) {
    document.querySelectorAll('.top-insta').forEach((el) => {
      el.style.display = 'none'
    })
  }
})
